export default __webpack_public_path__ + "static/media/pic1.e3422ba9.jpg";